import React, { Component } from 'react';
import CountUp from 'react-countup';
import {
  intlShape,
  injectIntl
} from 'react-intl';

const propTypes = {
  intl: intlShape.isRequired,
};

class Last30 extends Component {
  render() {
    return(
    <div>
    <div className="row">
        <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12">
          <a className="dashboard-stat dashboard-stat-v2 blue" href="#">
            <div className="visual">
              <i className="fa fa-globe"></i>
            </div>
            <div className="details">
              <div className="number">
                <span data-counterup-delay="30" data-counter="counterup" data-value={this.props.intl.formatNumber(this.props.stats.impressions)}><CountUp start={0} duration={1.5} end={this.props.stats.impressions} /></span>
              </div>
              <div className="desc"> Einblendungen </div>
            </div>
          </a>
        </div>
        <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12">
          <a className="dashboard-stat dashboard-stat-v2 green" href="#">
            <div className="visual">
              <i className="fa fa-shopping-cart"></i>
            </div>
            <div className="details">
              <div className="number">
                <span data-counter="counterup" data-value={this.props.intl.formatNumber(this.props.stats.conversions)}><CountUp start={0} duration={1.5} end={this.props.stats.conversions} /></span>
              </div>
              <div className="desc"> Verkäufe </div>
            </div>
          </a>
        </div>
        <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12">
          <a className="dashboard-stat dashboard-stat-v2 purple" href="#">
            <div className="visual">
              <i className="fa fa-cart-plus"></i>
            </div>
            <div className="details">
              <div className="number">
                <span data-counter="counterup" data-value={this.props.intl.formatNumber(this.props.stats.productsSold)}><CountUp start={0} duration={1.5} end={this.props.stats.productsSold} /></span>
              </div>
              <div className="desc"> verkaufte Produkte </div>
            </div>
          </a>
        </div>
        <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12">
          <a className="dashboard-stat dashboard-stat-v2 red" href="#">
            <div className="visual">
              <i className="fa fa-bar-chart-o"></i>
            </div>
            <div className="details">
              <div className="number">
                <span data-counter="counterup" data-value={this.props.intl.formatNumber(this.props.stats.expenses, {style: 'currency', currency: 'EUR'})}><CountUp start={0} duration={1.5} end={this.props.stats.expenses} decimals="2" decimal="," prefix="EUR "/></span>
              </div>
              <div className="desc"> Kosten </div>
            </div>
          </a>
        </div>
        <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12">
          <a className="dashboard-stat dashboard-stat-v2 yellow" href="#">
            <div className="visual">
              <i className="fa fa-bank"></i>
            </div>
            <div className="details">
              <div className="number">
                <span data-counter="counterup" data-value={this.props.intl.formatNumber(this.props.stats.turnover, {style: 'currency', currency: 'EUR'})}><CountUp start={0} duration={1.5} end={this.props.stats.turnover} decimals="2" decimal="," prefix="EUR "/></span>
              </div>
              <div className="desc"> Umsätze </div>
            </div>
          </a>
        </div>
        <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12">
          <a className="dashboard-stat dashboard-stat-v2 grey" href="#">
            <div className="visual">
              <i className="fa fa-calculator"></i>
            </div>
            <div className="details">
              <div className="number">
                <span data-counter="counterup" data-value={this.props.intl.formatNumber((this.props.stats.conversions !== 0 ? this.props.stats.turnover / this.props.stats.conversions : 0), {style: 'currency', currency: 'EUR'})}><CountUp start={0} duration={1.5} end={(this.props.stats.conversions !== 0 ? this.props.stats.turnover / this.props.stats.conversions : 0)} decimals="2" decimal="," prefix="EUR "/></span>
              </div>
              <div className="desc"> Durchschnittsumsatz pro Verkauf </div>
            </div>
          </a>
        </div>
    </div>
    </div>
  )
  }
}

Last30.propTypes = propTypes;

export default injectIntl(Last30);



// WEBPACK FOOTER //
// ./src/components/stats/Last30.js